import React from "react";

const SERVICE_CARDS = [
  {
    label: "Food & Beverages",
    img: "/img/foodbeverages.jpg",
    href: "/Food",
    desc: "Choose the perfect food combo for your celebration.",
    pill: "✨ Popular",
    icon: "🍽️",
  },
  {
    label: "Cakes",
    img: "/img/c4.jpg",
    href: "/cakes",
    desc: "Choose the perfect cake from our delicious selection.",
    pill: "🎂 Custom",
    icon: "🎂",
  },
  {
    label: "Screening",
    img: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=600&q=80",
    fallback: "/assets/img/screening-theatre.jpg",
    href: null,
    desc: "Bring your OTT account and relive the theatre magic!",
    pill: "🎬 Cinematic",
    icon: "🎬",
  },
  {
    label: "Bouquets",
    img: "https://images.unsplash.com/photo-1582794543139-8ac9cb0f7b11?w=600&q=80",
    href: "/bouquets",
    desc: "Add a beautiful bouquet to your celebration.",
    pill: "🌹 Fresh",
    icon: "🌹",
  },
  {
    label: "Photography",
    img: "https://api.carnivalcastle.com/uploads/galleryImg/1774802984680-WhatsApp Image 2026-03-29 at 10.19.07 PM.jpeg",
    href: "/gallery",
    desc: "Capture every precious memory with our professional photography service.",
    pill: "📸 Premium",
    icon: "📸",
    viewMoreLabel: "View More",
  },
];

export default function ServicesSection() {
  return (
    <section className="svc-section-root">
      <div className="container">
        <div className="text-center rv" style={{ marginBottom: 32 }}>
          <span className="svc-tag-pill">✦ Our Services ✦</span>
          <h2 className="svc-heading">
            Everything You <span>Need</span>
          </h2>
          <p className="svc-subheading">
            Cakes, food, screening, bouquets &amp; photography — all curated to
            make your event absolutely perfect.
          </p>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 14,
            marginBottom: 36,
          }}
        >
          <div
            style={{
              flex: 1,
              height: 1,
              background:
                "linear-gradient(90deg, transparent, rgba(201, 168, 76, 0.25), transparent)",
            }}
          />
          <div
            style={{
              width: 7,
              height: 7,
              background: "#C9A84C",
              transform: "rotate(45deg)",
              flexShrink: 0,
            }}
          />
          <div
            style={{
              flex: 1,
              height: 1,
              background:
                "linear-gradient(90deg, rgba(201, 168, 76, 0.25), transparent)",
            }}
          />
        </div>

        {/* 5-column compact grid */}
        <div className="svc-grid-five rv">
          {SERVICE_CARDS.map((s, i) => (
            <div key={i} className="svc-card-premium">
              <div className="svc-img-wrap">
                <img
                  src={s.img}
                  alt={s.label}
                  className="svc-img-premium"
                  loading="lazy"
                  onError={(e) => {
                    if (s.fallback && e.currentTarget.src !== s.fallback) {
                      e.currentTarget.src = s.fallback;
                    }
                  }}
                />
                <div className="svc-glow-ovl" />
                <div className="svc-num-badge">0{i + 1}</div>
                <div className="svc-pill-tag">{s.pill}</div>
              </div>
              <div className="svc-body-premium">
                <div className="svc-float-icon">{s.icon}</div>
                <div className="svc-title-premium">{s.label}</div>
                <span className="svc-anim-line" />
                <p className="svc-desc-premium">{s.desc}</p>
                {s.href && (
                  <a href={s.href} className="svc-view-link">
                    {s.viewMoreLabel || "View More"}{" "}
                    <span className="svc-link-arr">→</span>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center" style={{ marginTop: 6 }}>
          <a
            href="https://wa.me/918341428342"
            target="_blank"
            rel="noopener noreferrer"
            className="wa-btn"
            style={{ margin: "0 auto", padding: "10px 22px", fontSize: 13 }}
          >
            <i className="bi bi-whatsapp" /> Chat With Us
          </a>
        </div>
      </div>

      <style>{`
        /* ── Section Background & Luxury UI ── */
        .svc-section-root {
          padding: 56px 0 62px;
          background: radial-gradient(120% 80% at 50% 0%, rgba(94, 14, 115, 0.04) 0%, transparent 60%),
                      radial-gradient(80% 60% at 90% 100%, rgba(201, 168, 76, 0.06) 0%, transparent 60%),
                      #F7F3EC;
          position: relative;
          overflow: hidden;
          border-top: 1px solid rgba(201, 168, 76, 0.18);
          border-bottom: 1px solid rgba(94, 14, 115, 0.08);
        }

        .svc-tag-pill {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: rgba(201, 168, 76, 0.14);
          border: 1px solid rgba(201, 168, 76, 0.35);
          color: #8C6A1A;
          font-size: 10.5px;
          font-weight: 700;
          letter-spacing: 2px;
          text-transform: uppercase;
          padding: 4px 14px;
          border-radius: 50px;
          margin-bottom: 10px;
        }

        .svc-heading {
          font-family: 'Playfair Display', Georgia, serif;
          font-size: clamp(26px, 3.2vw, 36px);
          font-weight: 700;
          color: #1A0030;
          margin: 0 0 8px;
          line-height: 1.2;
        }

        .svc-heading span {
          color: #5E0E73;
        }

        .svc-subheading {
          font-size: 13.5px;
          color: #61556B;
          max-width: 520px;
          margin: 0 auto;
          line-height: 1.6;
        }

        /* ── 5-Column Compact Grid ── */
        .svc-grid-five {
          display: grid;
          grid-template-columns: repeat(5, minmax(0, 1fr));
          gap: 13px;
          margin-bottom: 28px;
        }

        /* ── Compact Card Architecture ── */
        .svc-card-premium {
          border-radius: 14px !important;
          overflow: hidden;
          background: #FFFFFF !important;
          border: 1px solid #E6DCCD !important;
          box-shadow: 0 4px 14px rgba(26, 0, 48, 0.05) !important;
          transition: transform 0.28s ease, box-shadow 0.28s ease, border-color 0.28s ease !important;
          cursor: pointer;
          position: relative;
          display: flex;
          flex-direction: column;
        }

        .svc-card-premium:hover {
          transform: translateY(-5px) !important;
          border-color: #C9A84C !important;
          box-shadow: 0 12px 28px rgba(94, 14, 115, 0.12) !important;
        }

        /* Compact Image Box (Reduced from 220px to 135px) */
        .svc-img-wrap {
          position: relative;
          height: 135px !important;
          overflow: hidden;
          background: #FAFAF7;
        }

        .svc-img-premium {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition: transform 0.45s ease !important;
        }

        .svc-card-premium:hover .svc-img-premium {
          transform: scale(1.05) !important;
        }

        /* Compact Badges */
        .svc-num-badge {
          position: absolute;
          top: 7px !important;
          right: 7px !important;
          width: 24px !important;
          height: 24px !important;
          font-size: 10px !important;
          font-weight: 700 !important;
          background: rgba(26, 0, 48, 0.72) !important;
          border: 1px solid rgba(201, 168, 76, 0.6) !important;
        }

        .svc-pill-tag {
          position: absolute;
          bottom: 7px !important;
          left: 7px !important;
          font-size: 7.5px !important;
          padding: 2px 7px !important;
          letter-spacing: 0.8px !important;
          border-radius: 20px !important;
        }

        /* Compact Card Body (Reduced Padding) */
        .svc-body-premium {
          padding: 15px 12px 13px !important;
          position: relative;
          display: flex;
          flex-direction: column;
          flex: 1;
        }

        .svc-float-icon {
          position: absolute;
          top: -13px !important;
          left: 12px !important;
          width: 26px !important;
          height: 26px !important;
          font-size: 12px !important;
          border-radius: 7px !important;
          box-shadow: 0 3px 8px rgba(94, 14, 115, 0.3) !important;
        }

        .svc-title-premium {
          font-family: 'Playfair Display', Georgia, serif;
          font-size: 14px !important;
          font-weight: 700;
          color: #1A0030 !important;
          margin: 0 0 2px !important;
          line-height: 1.25;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .svc-anim-line {
          margin: 3px 0 5px !important;
          height: 1.5px !important;
        }

        .svc-desc-premium {
          font-size: 11px !important;
          color: #7A7082 !important;
          line-height: 1.4 !important;
          margin: 0 0 6px !important;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          min-height: 31px;
        }

        .svc-view-link {
          margin-top: auto !important;
          font-size: 11px !important;
          padding-top: 2px;
        }

        /* ── Responsive Adaptations ── */
        @media (max-width: 1200px) {
          .svc-grid-five {
            grid-template-columns: repeat(4, 1fr);
            gap: 12px;
          }
        }

        @media (max-width: 960px) {
          .svc-grid-five {
            grid-template-columns: repeat(3, 1fr);
            gap: 12px;
          }
        }

        @media (max-width: 720px) {
          .svc-grid-five {
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
          }
          .svc-img-wrap {
            height: 125px !important;
          }
        }

        @media (max-width: 440px) {
          .svc-grid-five {
            grid-template-columns: 1fr;
            gap: 12px;
          }
        }
      `}</style>
    </section>
  );
}